import Profile from "./index"
export const paths = [
    {
        path: "/profile",
        component: Profile
    }
]


// WEBPACK FOOTER //
// ./src/views/User/Profile/routers.js